import React, { Component } from 'react'
import './Presentation.css'
import { Image } from 'react-bootstrap'
import Logo from '../../assets/img/logo_wejdi1.png'
import {  TypingStep } from "typing-effect-reactjs";
import AnimatedButton from '../shared/button/Button'
import cv1 from '../../assets/img/cv1.png';
import cv2 from '../../assets/img/cv2.png';
import cv3 from '../../assets/img/cv3.png';
import cv4 from '../../assets/img/cv4.png';
import cv5 from '../../assets/img/cv5.png';
import cv6 from '../../assets/img/cv6.png';
import cv from '../../assets/document/Wejdi Gharbi Resume.pdf';
import Zoom from 'react-reveal/Zoom';

const images = [
    cv1,
    cv2,
    cv3,
    cv4,
    cv5,
    cv6
  ];

export default class Presentation extends Component {
    render() {
        return (
            <div id="about" className="presentation-container" >

                <div className="presentation-container-about" >
                  <Zoom> 
                    <Image src={Logo} rounded className="presentation-logo" />
                    </Zoom> 
                    <div className="presentation-text">

                        <TypingStep
                            sequence={[
                                {
                                    content: "  Hi  👋,  I am Wejdi ,\n ",
                                },
                                
                                {
                                    content: "💡 Professional Scrum Master PSM® and Professional Scrum Product Owner PSPO® Certified.\n ",
                                },

                                {
                                    content: "💡 A creative software engineer specialized in front-end using ReactJS, back-end using Spring Boot and mobile applications using Cordova.\n ",
                                },
                                          
                                {
                                    content: "💡 Analysis, design, and development ergonomic and responsive web interfaces.\n",
                                  
                                },
                                                                
                                {
                                    content: "💡 Development of applications in microservices architecture, Continuous integration and unit tests.\n",
                                  
                                },

                                {
                                    content: "💡 A keen eye for creating engaging UI, bringing products to life... ",
                                }

                            ]}
                            
                            typeSpeed={95} 
                            cursorColor = "white"
 
                        />


                    </div>

                    <AnimatedButton title="My Resume" images={images}  douwnload={true} file={cv} />


                </div>


            </div>
        )
    }
}
